function parallaxImages() {
    const pImages = document.querySelectorAll('.js-parallax-image');

    pImages.forEach(el => {
        const imgParent = el.parentNode;

        parallaxImg(el, imgParent);
    });

    window.requestAnimationFrame(parallaxImages);
}

function parallaxImg(img, parent) {
    const parentDetails = parent.getBoundingClientRect(),
        winY = window.pageYOffset,
        winH = window.innerHeight,
        imgY = parentDetails.top + winY,
        parentH = parentDetails.height,
        winBottom = winY + winH,
        speed = 0.75;

    let imgPercent = 0;

    // If block is shown on screen
    if (winBottom > imgY && winY < imgY + parentH) {
        // Number of pixels shown after block appear
        const imgBottom = ((winBottom - imgY) * speed),
            // Max number of pixels until block disappear
            imgTop = winH + parentH;
        
        // Percentage between start showing until disappearing
        imgPercent = ((imgBottom / imgTop) * 100) + (50 - (speed * 50));
    }

    // Update img CSS
    img.style.top = `${imgPercent}%`;
    img.style.transform = `translate(-50%, -${imgPercent}%)`;
}

export function init() {
    // Setup animation frame
    window.requestAnimationFrame(parallaxImages);
}